import _ from 'lodash';
import { FacebookIcon, FacebookShareButton, LineIcon, LineShareButton, TwitterShareButton } from 'react-share';
import { NextPage } from 'next';
import { APP_URL } from 'src/constants/index';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { ISocialList } from 'src/interface/widgets';
import { IDataLayerGlobal } from 'src/interface/data-layer';
import styled from '@emotion/styled';
import { BsTwitterX } from 'react-icons/bs';


type Props = {
  title?: string;
  articleLink?: string;
  eventDataLayer?: IDataLayerGlobal;
};
const WidgetSocial: NextPage<Props> = ({ articleLink, eventDataLayer = {} }) => {
  if (_.isEmpty(articleLink)) return null;
  const shareLink: string = `${APP_URL}${articleLink}`;

  const SOCIAL_LIST: ISocialList[] = [
    {
      id: 1,
      icon: (
        <FacebookShareButton url={shareLink}>
          <FacebookIcon size={20} round={true} />
        </FacebookShareButton>
      ),
      link: shareLink,
      name: 'facebook',
      className: 'icon-facebook'
    },
    {
      id: 2,
      icon: (
        <LineShareButton url={shareLink}>
          <LineIcon size={20} round={true} />
        </LineShareButton>
      ),
      link: shareLink,
      name: 'line',
      className: 'icon-line'
    },
    {
      id: 3,
      icon: (
        <TwitterShareButton url={shareLink}>
          <div className='x-wrapper'>
            <BsTwitterX size={20} />
          </div>
        </TwitterShareButton>
      ),
      link: shareLink,
      name: 'X',
      className: 'icon-X'
    }
  ];
  return (
    <>
      <WidgetWrapper className='widget-social-share'>
        {/* <div className='title'>{title}</div> */}
        <div className='list-items'>
          {SOCIAL_LIST.map((item: ISocialList, index: number) => (
            <p
              tabIndex={-1}
              // target='_blank'
              key={index}
              // rel='noopener nopopopener'
              // aria-label='social-share'
              title='social-share'
              className={`${item?.className}`}
              // ! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    title: item?.name,
                    heading: item?.name,
                    index: index + 1
                  }
                })
              }
            >
              {item?.icon}
            </p>
          ))}
        </div>
      </WidgetWrapper>
    </>
  );
};

const WidgetWrapper = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  max-height: 100px;
  gap: 20px;
  /* margin: 10px 0; */
  .title {
    vertical-align: middle;
    font-weight: 700;
    font-size: 16px;
    padding: 0 10px;
    border-bottom: 2px solid var(--primary-color);
  }
  .list-items {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .icon-facebook {
    background-color: #1877f2;
  }
  .icon-line {
    background-color: #00cf2e;
  }
  .icon-twitter {
    background-color: #24acff;
  }
  p {
    display: flex;
    padding: 0px;
    margin: 0;
    border-radius: 100%;
    background-color: transparent;
    transition: 100ms all ease-in-out;
    button {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    button > svg {
      margin-right: 0 !important;
    }
    svg {
      display: flex;
      justify-content: center;
      align-items: center;
      vertical-align: middle;
      height: 35px;
      width: 35px;
      @media (max-width: 475px) {
        height: 30px;
        width: 30px;
        padding: 0;
      }
    }
    svg circle {
      fill: transparent;
    }
    svg path {
      fill: #fff;
    }
    &:hover {
      background-color: var(--primary-color);
      svg path {
        fill: white;
      }
    }
  }
  .x-wrapper {
    width: 35px;
    height: 35px;
    background-color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    @media (max-width: 475px) {
      width: 29px;
      height: 29px;
    }
    &:hover {
      background-color: var(--primary-color);
    }
    svg {
      color: #fff;
      font-size: 18px;
      padding: 10px;
      margin-right: unset;
    }
  }
`;
export default WidgetSocial;
